// BIA Studio — Apple-grade light design tokens

export const colors = {
  // Surfaces
  canvas: "#F5F5F7", // 3D viewport backdrop
  bg: "#FBFBFD", // app background (off-white)
  surface: "#FFFFFF", // elevated cards
  glass: "rgba(255,255,255,0.72)",
  glassStrong: "rgba(255,255,255,0.86)",

  // Text
  textPrimary: "#1D1D1F",
  textSecondary: "#6E6E73",
  textTertiary: "#86868B",

  // Hairlines / borders
  border: "rgba(0,0,0,0.08)",
  borderStrong: "rgba(0,0,0,0.14)",
  glassBorder: "rgba(255,255,255,0.7)",

  // Pillar accents (base solid) — legacy palette (Hotfix 5.0 rollback)
  pillar: {
    location: "#51aafe",
    systems: "#f88528",
    crops: "#71d85e",
    resources: "#3bbbc2",
  },

  ok: "#71d85e",
  warn: "#f88528",

  // Master brand — Primary Blue (upload screen, CTAs, engine title)
  brand: "#51aafe",
  brandDeep: "#2E86D9",
};

// Fluid multi-stop gradients for the premium rings
export const pillarGradients = {
  location: ["#51aafe", "#93C9FF"],
  systems: ["#f88528", "#FBAB63"],
  crops: ["#71d85e", "#A2E893"],
  resources: ["#3bbbc2", "#74D6DA"],
};

export const brandGradient = ["#51aafe", "#2E86D9"];

// Contextual fade generator — a low-opacity wash of a hex, for callouts & inactive card
// backgrounds tinted to the active ring. Accepts #RGB / #RRGGBB.
export function fade(hex, alpha = 0.15) {
  let h = (hex || "").replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const int = parseInt(h || "000000", 16);
  const r = (int >> 16) & 255, g = (int >> 8) & 255, b = int & 255;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// Faded wash for a given ring pillar id ("locations" | "systems" | "crops" | "resources").
const PILLAR_HEX = { locations: "#51aafe", systems: "#f88528", crops: "#71d85e", resources: "#3bbbc2" };
export function pillarFade(pillarId, alpha = 0.15) {
  return fade(PILLAR_HEX[pillarId] || "#498DCC", alpha);
}
export { PILLAR_HEX };

export const fonts = {
  sans:
    '-apple-system, BlinkMacSystemFont, "SF Pro Display", "SF Pro Text", "Segoe UI", system-ui, sans-serif',
  mono: '"SF Mono", ui-monospace, "SFMono-Regular", Menlo, Monaco, monospace',
};

// Layered, diffuse elevation shadows (Apple spatial language)
export const shadows = {
  card: "0 1px 2px rgba(0,0,0,0.04), 0 8px 24px rgba(0,0,0,0.06)",
  float:
    "0 1px 2px rgba(0,0,0,0.04), 0 12px 32px rgba(0,0,0,0.08), 0 32px 64px rgba(0,0,0,0.05)",
  soft: "0 1px 3px rgba(0,0,0,0.05), 0 4px 12px rgba(0,0,0,0.05)",
};

export const spacing = { micro: 4, s: 8, m: 16, l: 24, xl: 32, xxl: 48 };

export const radii = { sm: 10, md: 16, lg: 22, xl: 28, pill: 999 };
